import { Component, OnInit } from '@angular/core';

import { RedirectionService } from '~/core/services/redirection/redirection.service';

@Component({
  selector: 'app-auth-logout',
  templateUrl: './logout.component.html',
})
export class AuthPageLogoutComponent implements OnInit {
  constructor(private readonly redirectionService: RedirectionService) {}

  public ngOnInit(): void {
    this.redirectionService.redirect('attendee.homepage');
  }
}
